
import type { RouteObject } from "react-router-dom";
import { lazy, Suspense } from "react";
import NotFound from "../pages/NotFound";

// Lazy load components for better performance
const Home = lazy(() => import("../pages/home/page"));
const Projects = lazy(() => import("../pages/projects/page"));
const ProjectDetail = lazy(() => import("../pages/projects/project-detail"));
const Donate = lazy(() => import("../pages/donate/page"));
const About = lazy(() => import("../pages/about/page"));

// Loading component
const LoadingSpinner = () => (
  <div className="min-h-screen bg-white flex items-center justify-center">
    <div className="flex flex-col items-center space-y-4">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      <p className="text-gray-600">Loading...</p>
    </div>
  </div>
);

const routes: RouteObject[] = [
  {
    path: "/",
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <Home />
      </Suspense>
    ),
  },
  {
    path: "/projects",
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <Projects />
      </Suspense>
    ),
  },
  {
    path: "/projects/:id",
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <ProjectDetail />
      </Suspense>
    ),
  },
  {
    path: "/donate",
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <Donate />
      </Suspense>
    ),
  },
  {
    path: "/about",
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <About />
      </Suspense>
    ),
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
